import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
  const onSubscribe = (e) => {
    e.preventDefault();
    const email = new FormData(e.currentTarget).get("email");
    if (!email) return;
    toast.success("Thank you — welcome to the Innayaa circle.");
    e.currentTarget.reset();
  };

  return (
    <footer data-testid="site-footer" className="bg-[#F0EBE1] border-t border-[#DCD5CA] mt-16 md:mt-24">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-14 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          {/* Newsletter */}
          <div className="md:col-span-5">
            <p className="overline">The Innayaa Letter</p>
            <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl leading-tight text-[#2A2626] mt-3">
              Slow beauty, delivered gently to your inbox.
            </h3>
            <p className="mt-4 text-[15px] text-[#5C564F] max-w-md leading-relaxed">
              New drops, gemstone stories, and quiet inspiration — no more than once a fortnight.
            </p>
            <form onSubmit={onSubscribe} className="mt-6 md:mt-8 flex items-center gap-0 max-w-md">
              <input
                data-testid="newsletter-email-input"
                type="email"
                name="email"
                required
                placeholder="your@email.com"
                className="flex-1 bg-transparent border-b border-[#2A2626] px-2 py-3 text-[#2A2626] placeholder:text-[#5C564F]/60 focus:outline-none focus:border-[#2A2626] font-sans text-sm"
              />
              <button
                data-testid="newsletter-submit-button"
                type="submit"
                className="ml-4 uppercase text-[11px] tracking-[0.24em] text-[#2A2626] border-b border-[#2A2626] pb-3 hover:opacity-70 transition-opacity"
              >
                Subscribe
              </button>
            </form>
          </div>

          <div className="md:col-span-2">
            <p className="overline">Shop</p>
            <ul className="mt-4 space-y-3 font-sans text-sm text-[#2A2626]">
              <li><Link data-testid="footer-shop-all" to="/shop" className="hover:opacity-70">All</Link></li>
              <li><Link to="/shop/earrings" className="hover:opacity-70">Earrings</Link></li>
              <li><Link to="/shop/pendants" className="hover:opacity-70">Pendants</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline">House</p>
            <ul className="mt-4 space-y-3 font-sans text-sm text-[#2A2626]">
              <li><Link to="/about" className="hover:opacity-70">Our Story</Link></li>
              <li><Link to="/contact" className="hover:opacity-70">Contact</Link></li>
              <li><a href="#" className="hover:opacity-70">Care Guide</a></li>
              <li><a href="#" className="hover:opacity-70">Journal</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Service</p>
            <ul className="mt-4 space-y-3 font-sans text-sm text-[#2A2626]">
              <li><Link data-testid="footer-return-policy" to="/return-exchange-policy" className="hover:opacity-70">Return &amp; Exchange Policy</Link></li>
              <li><Link data-testid="footer-shipping-policy" to="/shipping-policy" className="hover:opacity-70">Shipping Policy</Link></li>
              <li><a href="#" className="hover:opacity-70">FAQ</a></li>
              <li><Link data-testid="footer-privacy-policy" to="/privacy-policy" className="hover:opacity-70">Privacy Policy</Link></li>
              <li><Link data-testid="footer-terms" to="/terms-and-conditions" className="hover:opacity-70">Terms &amp; Conditions</Link></li>
            </ul>
            <div className="flex items-center gap-5 mt-6 md:mt-8 text-[#2A2626]">
              <a
                data-testid="footer-instagram-link"
                href="https://www.instagram.com/innayaa.in/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:opacity-70"
              >
                <Instagram strokeWidth={1.5} size={20} />
              </a>
              <a
                data-testid="footer-email-link"
                href="mailto:innayaaofficial@gmail.com"
                aria-label="Email"
                className="hover:opacity-70"
              >
                <Mail strokeWidth={1.5} size={20} />
              </a>
              <a
                data-testid="footer-phone-link"
                href="tel:+918240044327"
                aria-label="Call customer support"
                className="hover:opacity-70"
              >
                <Phone strokeWidth={1.5} size={20} />
              </a>
            </div>
            <a
              data-testid="footer-support-number"
              href="tel:+918240044327"
              className="mt-4 block text-[11px] uppercase tracking-[0.22em] text-[#5C564F] hover:text-[#2A2626]"
            >
              Support · +91 82400 44327
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 md:pt-8 border-t border-[#DCD5CA] flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-serif text-lg text-[#2A2626]">Innayaa</p>
          <p
            data-testid="footer-copyright"
            className="text-[10px] md:text-xs uppercase tracking-[0.24em] text-[#5C564F]"
          >
            © {new Date().getFullYear()} Innayaa · Handcrafted in India
          </p>
        </div>

        <div className="mt-5 md:mt-6 pt-4 border-t border-[#DCD5CA] text-center">
          <p
            data-testid="developed-by-credit"
            className="text-[10px] md:text-[11px] uppercase tracking-[0.28em] text-[#5C564F]"
          >
            Developed by Cube Multimedia.
          </p>
        </div>
      </div>
    </footer>
  );
}
